import { render, staticRenderFns } from "./GiftPaywall.vue?vue&type=template&id=5ac63e11&scoped=true&"
import script from "./GiftPaywall.vue?vue&type=script&lang=ts&"
export * from "./GiftPaywall.vue?vue&type=script&lang=ts&"
import style0 from "./GiftPaywall.vue?vue&type=style&index=0&id=5ac63e11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac63e11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5ac63e11', component.options)
    } else {
      api.reload('5ac63e11', component.options)
    }
    module.hot.accept("./GiftPaywall.vue?vue&type=template&id=5ac63e11&scoped=true&", function () {
      api.rerender('5ac63e11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/gifts/paywall/GiftPaywall.vue"
export default component.exports